/**
 * Component to Show sentReport mail
 *
 *
 *
 */

import React, { useState, useEffect, useRef, useContext } from 'react';
import ReportLink from '../report-link/report-link';
import { Form, Input, Space, Typography, Radio, message } from 'antd';
import { SCRFilesLink } from '../../../../models';
import { useTranslation, Button } from 'soxo-bootstrap-core';
const { Text } = Typography;

export default function SendReport({ props, billId,appointment_id, mail, callback }) {
    const [selected, setSelected] = useState({
        reports: [],
    });
    const [disable, setDisable] = useState(true);
    const [isLoading, setIsLoading] = useState(false);
    const [selectedReport, setSelectedReport] = useState(null);
    const [form] = Form.useForm();
    const [editedEmail, setEditedEmail] = useState('');
    const [reportKey, setReportKey] = useState(0); // used to force refresh ReportLink
    const { t, i18n } = useTranslation(); // To Translate to another language

    /**
     * The function `sendReportToMail` sends a report to a specified email address using an API call
     * and handles any errors that occur.
     */
    async function sendReportToMail() {
        setIsLoading(true);
        // let userData = {
        //     username: 'AUTOLOGIN2',
        //     password: 'Auto2@Log88',
        // };
        // // Fetching access token for report sending
        // const userDataDetails = await SCRFilesLink.getAccessTokenForReportSending(userData);

        const token = localStorage.access_token;
        const dbPtr = props.settings.headers.db_ptr.toString()

        /* The code is creating an object called `formBody` with three properties: `mail`, `report_id`,
       and `type`. */
        let formBody = {
            mail: props.isEmailEditable ? editedEmail || mail : mail,
            reports: selected,
            appointment_id:appointment_id
        };

        let response = await SCRFilesLink.sendReportMail(formBody, token, dbPtr);
        if (response.success) {
            setIsLoading(false);
            message.success(response.message);
            setDisable(true);
            setReportKey(prev => prev + 1); // trigger re-render
        } else {
            setIsLoading(false);
            message.error(response.message);
            setDisable(true);
            setReportKey(prev => prev + 1); // trigger re-render
        }

    }

    return (
        <div className="detail-element">
            <div>
                <ReportLink
                    key={reportKey} // 
                    billId={billId}
                    displayColumns={true}
                    selected={selected}
                    callback={values => {
                        setSelected(values);
                        // Enable a disabled element (like a submit button)
                        if (values && values.length > 0) {
                            setDisable(false);
                        } else {
                            setDisable(true);

                        }

                    }}
                />
            </div>
            <div style={{ marginTop: '10px' }}>
                <Form name="emailForm" onFinish={sendReportToMail} style={{ width: '450px' }} initialValues={{ email: mail }}>
                    <div className="card-title" style={{ width: '100%' }}>
                        <h3>{t('SEND VIA')}</h3>
                    </div>
                    <div style={{ display: 'flex', flexDirection: 'row' }}>
                        <Form.Item name="email" valuePropName="checked" initialValue={true}>
                            <Radio>{t('Email')}</Radio>
                        </Form.Item>
                        {/* <Form.Item name="whatsapp" valuePropName="checked" initialValue={false}>
                            <Radio>Whatsapp</Radio>
                        </Form.Item> */}
                    </div>
                    <Form.Item
                        name='email'
                    // rules={[
                    //     { required: true, message: 'Please enter your email!' },
                    //     { type: 'email', message: 'Please enter a valid email address!' },
                    // ]}
                    >
                        {props.isEmailEditable ? (
                            <Input
                                type="email"
                                value={mail}
                                onChange={(e) => setEditedEmail(e.target.value)}
                                style={{ width: '640px' }}
                            />
                        ) : (
                            <Input
                                type="email"
                                value={mail}
                                readOnly
                                style={{ width: '640px' }}
                            />
                        )}
                    </Form.Item>
                    {/* <Form.Item
                       
                        rules={[
                            { required: true, message: 'Enter whatsapp number!' },
                            { type: 'email', message: 'Please enter a valid number!' },
                        ]}
                    >
                        <Input placeholder="Enter Whatsapp Number" />
                    </Form.Item> */}
                    <Form.Item>
                        <Space>
                            <Button type="primary" htmlType="submit" loading={isLoading} disabled={disable}>
                                {t('Send Report')}
                            </Button>
                            <Button htmlType="button" onClick={callback}>
                                {t('Cancel')}
                            </Button>
                        </Space>
                    </Form.Item>
                </Form>
            </div>
        </div>
    );
}
